import PaginationArrow from '../icons/PaginationArrow';

type PaginationProps = {
	currentPage: number;
	totalPages: number;
	onPageChange: ( page: number ) => void;
};

/**
 * Pagination component.
 * Renders centered "X of Y" pagination with prev/next triangle arrows.
 *
 * @param {Object}   props              - Component props.
 * @param {number}   props.currentPage  - The active page number.
 * @param {number}   props.totalPages   - Total number of pages.
 * @param {Function} props.onPageChange - Callback when a page is selected.
 * @return {*} jsx
 */
export default function Pagination( { currentPage, totalPages, onPageChange }: PaginationProps ) {
	if ( totalPages <= 1 ) {
		return null;
	}

	return (
		<nav className="str-maps__pagination" aria-label="List pagination">
			<button
				className="str-maps__pagination-btn"
				aria-label="Previous page"
				disabled={ currentPage <= 1 }
				onClick={ () => onPageChange( currentPage - 1 ) }
			>
				<PaginationArrow direction="previous" />
			</button>
			<span className="str-maps__pagination-count" aria-live="polite" aria-atomic="true">
				{ currentPage } of { totalPages }
			</span>
			<button
				className="str-maps__pagination-btn"
				aria-label="Next page"
				disabled={ currentPage >= totalPages }
				onClick={ () => onPageChange( currentPage + 1 ) }
			>
				<PaginationArrow direction="next" />
			</button>
		</nav>
	);
}
